import debounce from "./utilities/debounce"

const blocks = document.querySelectorAll(".js-cascading-subtopics")

const CascadingSubtopics = {
	init: () => {
		if (!blocks.length) return

		blocks.forEach((block) => {
			CascadingSubtopics.fixPadding(block)
		})
		// Recalculer au redimensionnement de la fenêtre
		window.addEventListener(
			"resize",
			debounce(() => {
				blocks.forEach((block) => {
					CascadingSubtopics.fixPadding(block)
				})
			}, 100)
		)
	},

	fixPadding: (block) => {
		const cardsContainer = block.querySelector(".cascading-subtopics__cards")
		if (!cardsContainer) return

		const items = cardsContainer.querySelectorAll(".item-wrapper")
		if (!items.length) return

		const lastItem = items[items.length - 1]
		const isLastItemEven = items.length % 2 === 0
		const screenWidth = window.innerWidth

		// Réinitialiser le padding
		cardsContainer.style.paddingBottom = ""

		// Appliquer le padding uniquement si :
		// - largeur d'écran >= 1440px
		// - le dernier élément est pair (index impair car 0-based)
		// - le style cascading est activé
		if (screenWidth >= 1440 && isLastItemEven && cardsContainer.classList.contains("is-cascading")) {
			// Récupérer la hauteur du dernier élément
			const lastItemHeight = lastItem.offsetHeight
			// Appliquer un padding-bottom de 60% de la hauteur
			const paddingValue = lastItemHeight * 0.6
			cardsContainer.style.paddingBottom = `${paddingValue}px`
		}
	},
}

export default CascadingSubtopics
